export default function StatsDrawerToggle() {
  const handleClick = () => {
    const event = new CustomEvent('memePump:toggleStatsDrawer', {
      detail: { open: undefined }
    });
    window.dispatchEvent(event);

    try {
      const app = (window as any).memePumpApp;
      app?.audio?.play('ui-toggle', { allowRestart: true });
    } catch {}
  };

  return (
    <button
      id="stats-drawer-toggle-btn"
      class="button-secondary icon-btn"
      title="Stats Drawer"
      aria-label="Open stats drawer"
      onClick={handleClick}
    >
      <span class="icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 19h16" />
          <path d="M7 16v-5" />
          <path d="M12 16v-8" />
          <path d="M17 16v-11" />
          <path d="M6 11l4-4 3 3 5-6" />
        </svg>
      </span>
    </button>
  );
}
